import App from '../containers/App'

import SonosAquisitionPage from '../pages/SonosAquisitionPage'

const pageRoutes = [
  {
    path: '/',
    exact: true,
    component: SonosAquisitionPage
  },
  // redirects
  { path: '*', component: SonosAquisitionPage }
]

const routes = [
  {
    component: App,
    routes: pageRoutes
  }
]

export default routes

export function getWpPageIds () {
  return pageRoutes
    .map(p => p.wpPageId)
    .filter(wpPageId => typeof wpPageId === 'number')
}
